import { formatLocaleDate, formatLocaleNumber } from '../../../shared/localeFormatting.mjs';
import { useClubCurrency } from '@/context/ClubCurrencyContext';
import { formatDistanceToNow } from 'date-fns';
import { enGB, es } from 'date-fns/locale';
import { useCallback, useRef } from 'react';
import { useOptionalPrivanaI18n } from '@/i18n/PrivanaI18nProvider.jsx';

// Stable for operational callbacks: changing language never reloads or mutates data.
// Presentation memos explicitly depend on locale.
export function useBoardLocale() {
  const { timezone } = useClubCurrency();
  const { locale, t } = useOptionalPrivanaI18n();
  const translator = useRef(t);
  translator.current = t;
  const liveTranslate = useCallback((key, values) => translator.current(key, values), []);
  const date = (value, options = {}) => {
    if (!value || Number.isNaN(new Date(value).valueOf())) return '—';
    const displayOptions = { timeZone: timezone || 'UTC', ...options };
    // A date-only value has no timezone; optional malformed timezone metadata
    // must not prevent rendering an otherwise authorised record.
    if (/^\d{4}-\d{2}-\d{2}$/.test(String(value))) displayOptions.timeZone = 'UTC';
    try { return formatLocaleDate(value, locale, displayOptions); }
    catch { return formatLocaleDate(value, locale, { ...displayOptions, timeZone: 'UTC' }); }
  };
  const percent = (value) => value == null || !Number.isFinite(Number(value)) ? liveTranslate('boardPortal.nA') : formatLocaleNumber(Number(value) / 100, locale, { style: 'percent', minimumFractionDigits: 1, maximumFractionDigits: 1, signDisplay: 'exceptZero' });
  const relative = (value) => formatDistanceToNow(new Date(value), { addSuffix: true, locale: locale === 'es' ? es : enGB });
  return { locale, t: liveTranslate, date, percent, relative };
}
